import React from "react";
import RealmTitle from "../assets/images/realms.svg";
import RealmSliderInfo from "../components/RealmsSliderInfo";

const LearnAnimation = React.lazy(() => import("./LearnRealm"));
const InvestAnimation = React.lazy(() => import("./InvestRealm"));
const PlayAnimation = React.lazy(() => import("./PlayRealm"));
const DoGoodAnimation = React.lazy(() => import("./DoGoodRealm"));

const LearnTextAnimation = React.lazy(() => import("./LearnRealmText"));
const InvestTextAnimation = React.lazy(() => import("./InvestRealmText"));
const PlayTextAnimation = React.lazy(() => import("./PlayRealmText"));
const DoGoodTextAnimation = React.lazy(() => import("./DoGoodRealmText"));

function Realms() {
  return (
    <>
      <section
        id="realms"
        className="realms-section orbit-rings-no-outer-rings"
      >
        <img src={RealmTitle} alt="" />
        <div className="realm__block-info">
          Hover over the realms to learn more!
        </div>
        <RealmSliderInfo />
        <div className="realm__row">
          <div className="realm__learn">
            <div className="realm__content">
              <LearnTextAnimation />
              <LearnAnimation />
              <div className="realm__info">
                Idea exchange, learning, discovery, and non-linear growth in a
                limitless space for uniting Web3 insights
              </div>
            </div>
          </div>
          <div className="realm__build">
            <div className="realm__content">
              <InvestTextAnimation />
              <InvestAnimation />
              <div className="realm__info">
                Support the next generation of dreamers and builders and connect
                with like-minded believers in Web3
              </div>
            </div>
          </div>
          <div className="realm__play">
            <div className="realm__content">
              <PlayTextAnimation />
              <PlayAnimation />
              <div className="realm__info">
                Games, entertainment and fun in a joyful environment where
                unique engagement surrounds us all
              </div>
            </div>
          </div>
          <div className="realm__dogood">
            <div className="realm__content">
              <DoGoodTextAnimation />
              <DoGoodAnimation />
              <div className="realm__info">
                Contribute to society and protect our surrounding environments
                for a better future that benefits everyone
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Realms;
